    import React, { Fragment, useState } from 'react'
    import { useNavigate } from 'react-router-dom';
    const resourcesData = {
        categories: [
            { id: 1, title: "Guides", description: "In-depth resources to help you navigate challenges.", image: "/Resources/book.svg", color: "`bg-blue-100`" },
            { id: 2, title: "Blog", description: "Expert insights on mental health and wellness.", image: "/Resources/edit.svg", color: "bg-green-100" },
            { id: 3, title: "Assessments", description: "Self-assessments to better understand your needs.", image: "/Resources/brain.svg", color: "bg-purple-100" },
            { id: 4, title: "FAQs", description: "Answers to common questions about mental healthcare.", image: "/Resources/question.svg", color: "bg-orange-100" },
        ],
        articles: [
            { id: 1, title: "Managing Anxiety in Everyday Life", description: "Practical strategies to reduce worry, build coping skills, and feel more in control.", tag: "GUIDE", readTime: "8 min read", image: "/Resources/Blog1.svg" },
            { id: 2, title: "How Therapy Helps You Heal and Grow", description: "Explore the benefits of therapy and what to expect along the way.", tag: "BLOG", readTime: "5 min read", image: "/Resources/Blog2.svg" },
            { id: 3, title: "Building Self-Compassion", description: "Learn how to treat yourself with kindness—even on the hard days.", tag: "GUIDE", readTime: "10 min read", image: "/Resources/Blog3.svg" },
            { id: 4, title: "5 Mindfulness Practices for Busy Minds", description: "Simple ways to stay present and reduce stress, anytime.", tag: "BLOG", readTime: "6 min read", image: "/Resources/Blog4.svg" },
        ],
        assessments: [
            { id: 1, title: "Anxiety Check-In", description: "Understand your anxiety symptoms and their impact.", time: "5–7 min", image: "/Resources/icon1.svg", iconBg: "primary-bg" },
            { id: 2, title: "Depression Check-In", description: "Explore your mood and get personalized insights.", time: "6–7 min", image: "/Resources/icon2.svg", iconBg: "bg-green-100" },
            { id: 3, title: "Sleep Health Check", description: "Evaluate your sleep patterns and discover ways to improve.", time: "4–6 min", image: "/Resources/icon3.svg", iconBg: "bg-purple-100" },
            { id: 4, title: "Stress Check-In", description: "Identify stress triggers and learn how to manage them.", time: "5–6 min", image: "/Resources/icon4.svg", iconBg: "bg-orange-100" },
        ],
    };
    const tagConfig = {
        GUIDE: { bg: "bg-blue-100", text: "text-blue-700" },
        BLOG: { bg: "bg-green-100", text: "text-green-700" },
        WELLNESS: { bg: "bg-red-100", text: "text-red-600" },
        MINDFULNESS: { bg: "bg-purple-100", text: "text-purple-700" },
    };
    const ResourceData = () => {
        const [query, setQuery] = useState("");
        const navigate = useNavigate();

        const filteredArticles = resourcesData.articles.filter((a) =>
            a.title.toLowerCase().includes(query.toLowerCase())
        );

        return (
            <div className="min-h-screen bg-white ">
                {/* Here, I need to call hero */}

                <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 lg:px-8 ">
                    {/* categories section */}
                    <div className="mb-12 rounded-2xl ava-border  bg-white shadow-sm ">
                        <div className="flex flex-col divide-y divide-slate-100 sm:flex-row sm:divide-x sm:divide-y-0">
                            {resourcesData.categories.map((cat) => (
                                <div
                                    key={cat.id}
                                    className="group flex flex-1 cursor-pointer items-start gap-4 p-5 transition-colors duration-150 hover:bg-[var(--ava-card-bg)] sm:flex-col sm:items-start lg:flex-row lg:items-start"
                                >
                                    <div className="flex h-14 w-14 primary-bg shrink-0 items-center justify-center rounded-xl">
                                        <img src={cat.image} alt={cat.title} className="h-6 w-6 object-contain" />
                                    </div>
                                    <div className="min-w-0 flex-1">
                                        {/* ✅ Matches Conditions: font-semibold text-sm */}
                                        <p className="mb-1 ava-text-subheading ">
                                            {cat.title}
                                        </p>
                                        {/* ✅ Matches Conditions: text-xs leading-relaxed */}
                                        <p className="ava-text-xs ">
                                            {cat.description}
                                        </p>
                                    
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* Featured Articles */}
                    <div className="mb-5 flex flex-wrap items-baseline justify-between gap-2">
                        <div>
                            <h2 className=" mb-1" 
                            className="ava-heading-lg "
                            >Featured Articles</h2>
                            <p className="mt-0.5 ava-text-body">
                                Curated reads to inform, inspire, and support.
                                </p>
                        </div>
                    </div>
                    <div className="mb-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                        {filteredArticles.length > 0 ? (
                            filteredArticles.map((article) => {
                                const tc = tagConfig[article.tag] || 
                                { bg: "bg-slate-100", text: "text-slate-600" };
                                return (
                                    <div
                                        key={article.id}
                                        className="group cursor-pointer overflow-hidden rounded-2xl ava-border bg-white 
                                        "
                                    >

                                    {/* transition-all duration-200
                                        hover:-translate-y-1 hover:shadow-xl hover:shadow-[0_0px_2px_var(--primary-color)] */}
                                            
                                        <img src={article.image} alt={article.title}
                                            className="w-full aspect-[3/2] sm:aspect-[4/3] md:aspect-[16/9] object-cover object-center"
                                        />
                                        <div className="p-4">
                                            <div className="mb-2 flex items-center justify-between gap-2">
                                                <span className="rounded-md px-2.5 py-0.5  ava-text-caption tracking-wide ava-card-bg  whitespace-nowrap">
                                                    {article.tag}
                                                </span>
                                                <span className="flex items-center gap-1 ava-text-caption">
                                                    <div className="flex h-7 w-7 items-center justify-center rounded-full">
                                                        <img src='/Resources/time.svg' alt="" className="h-4 w-4 object-contain" />
                                                    </div>
                                                    {article.readTime}
                                                </span>
                                            </div>
                                            <p className="mb-1.5 ava-text-subheading">{article.title}</p>
                                            <p className="mb-3 ava-text-body">{article.description}</p>
                                            <button  className="ava-text-sm">
                                                Read more
                                            </button>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <p className="col-span-full text-sm text-slate-400">
                                No articles found for &ldquo;{query}&rdquo;.
                            </p>
                        )}
                    </div>
                    {/* self assessments */}
                    <div className="mb-5 flex flex-wrap items-baseline justify-between gap-2">
                        <div>
                            <h2 className="ava-heading-lg mb-1 " 
                            >Self-Assessments</h2>
                            <p className="mt-0.5 ava-text-xs">
                                Take a few minutes to gain clarity and insights. Your results are private and secure.
                            </p>
                        </div>
                    
                    </div>

                    <div className="mb-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                        {resourcesData.assessments.map((item) => (
                            <div
                                key={item.id}
                                className="cursor-pointer rounded-2xl border border-slate-200 ava-card-bg p-5 transition-all duration-200 hover:-translate-y-1 hover:shadow-lg hover:shadow-blue-100"
                            >
                                <div className="mb-4 flex h-11 w-11 items-center justify-center primary-bg rounded-xl">
                                    <img src={item.image} alt={item.title} className="h-6 w-6 object-contain" />
                                </div>
                                {/* ✅ Matches Conditions: font-semibold text-sm */}
                                <p className="mb-1.5 ava-text-subheading">{item.title}</p>
                                {/* ✅ Matches Conditions: text-xs leading-relaxed */}
                                <p className="mb-5 ava-text-xs">{item.description}</p>
                                <div className="flex items-center justify-between ">
                                    <span className="flex items-center gap-1 ava-text-xs ">
                                        <div className="flex h-7 w-7 items-center justify-center rounded-full">
                                            <img src='/Resources/time.svg' alt={item.title} className="h-4 w-4 object-contain"  />
                                        </div>
                                        {item.time}
                                    </span>
                                    <button style={{ backgroundColor: 'var(--primary-color)', color: 'white' }}
                                        className="rounded-md px-5 py-1.5 ava-text-xs  text-white transition hover:bg-blue-600"
                                        // className='btn-primary'
                                        >
                                        Start
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>          
            </div>
        )
    }

    export default ResourceData